import { c as _c } from "react/compiler-runtime";
import type { EmotionCache } from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import React, { createContext, useContext, useMemo } from "react";
import { createEmotionCache } from "#/shared/emotion/createEmotionCache";

/**
 * Set by _document enhanceApp during SSR so the app uses the same cache
 * we extract styles from. Null on the client.
 */
export const EmotionCacheContext = createContext<EmotionCache | null>(null);
let clientCache: EmotionCache | null = null;
function getClientCache(): EmotionCache {
  if (!clientCache) clientCache = createEmotionCache();
  return clientCache;
}

/**
 * Provides Emotion cache: server cache from context during SSR, client singleton otherwise.
 * Keeps cache key consistent so MUI class names don't mismatch (css- prefix).
 */
export const EmotionCacheProvider: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(5);
  const {
    children
  } = t0;
  const serverCache = useContext(EmotionCacheContext);
  let t1;
  if ($[0] !== serverCache) {
    t1 = serverCache ?? getClientCache();
    $[0] = serverCache;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cache = t1;
  let t2;
  if ($[2] !== cache || $[3] !== children) {
    t2 = <CacheProvider value={cache}>{children}</CacheProvider>;
    $[2] = cache;
    $[3] = children;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};